import React from "react";
import SignIn from "./components/SignIn";

const routes = [
  { name: "Connexion", path: "/connexion", exact: true, main: () => <SignIn /> }
];

export default routes;